import React from "react";

// Choose Your Therapist logo: the square brand mark + the name set in Inter (loaded in
// public/index.html), so it stays crisp and readable at small sizes — the outlined
// letters of the full SVG logo went thin and too bright from a distance.
// size: "sm" (sidebar) | "lg" (login).
const SIZES = {
  sm: { mark: 30, small: 9, big: 18, gap: 8 },
  lg: { mark: 46, small: 13, big: 27, gap: 12 },
};

export default function BrandLogo({ size = "sm", className = "" }) {
  const s = SIZES[size] || SIZES.sm;
  return (
    <span className={`cyt-brand ${className}`} style={{ gap: s.gap }} aria-label="Choose Your Therapist" role="img">
      <img src="/cyt-mark.svg" width={s.mark} height={s.mark} alt="" />
      <span className="cyt-brand-txt" aria-hidden="true">
        <span className="cyt-brand-small" style={{ fontSize: s.small }}>CHOOSE YOUR</span>
        <span className="cyt-brand-big" style={{ fontSize: s.big }}>THERAPIST</span>
      </span>
      <style>{BRAND_CSS}</style>
    </span>
  );
}

const BRAND_CSS = `
.cyt-brand { display: inline-flex; align-items: center; font-family: 'Inter', sans-serif; white-space: nowrap; }
.cyt-brand > img { display: block; flex-shrink: 0; }
.cyt-brand-txt { display: flex; flex-direction: column; line-height: 1; min-width: 0; }
.cyt-brand-small { font-weight: 700; letter-spacing: .17em; color: #334155; }
.cyt-brand-big { font-weight: 800; letter-spacing: .015em; color: #14532d; line-height: .9; margin-top: .08em; }
`;
